import { useMatch } from 'react-router';

import { homeRoutesConfig } from 'domains/home/routes';
import { platformSwaggerRoutesConfig } from 'domains/platformSwagger/routes';
import { pricingRoutesConfig } from 'domains/pricing/routes';
import { referralsRoutesConfig } from 'domains/referrals/routes';
import { statisticsRoutesConfig } from 'domains/statistics/routes';
import { swaggerUIRoutesConfig } from 'domains/swaggerUI/routes/constants';

export const useDefaultLayout = () => {
  const isHomePage = Boolean(useMatch(homeRoutesConfig.home.path));

  const isNewsPage = Boolean(useMatch(homeRoutesConfig.news.path));

  const isStatisticsPage = Boolean(
    useMatch(statisticsRoutesConfig.statistics.path),
  );

  const isPricingPage = Boolean(useMatch(pricingRoutesConfig.pricing.path));

  const isReferralsPage = Boolean(
    useMatch(referralsRoutesConfig.referrals.path),
  );

  const isPlatformSwaggerPage = Boolean(
    useMatch(platformSwaggerRoutesConfig.platformSwagger.path),
  );

  const isSwaggerUIPage = Boolean(
    useMatch(swaggerUIRoutesConfig.swaggerUI.path),
  );

  return {
    isHomePage: isHomePage && !isNewsPage,
    isNewsPage,
    isPlatformSwaggerPage,
    isPricingPage,
    isReferralsPage,
    isStatisticsPage,
    isSwaggerUIPage,
  };
};
